import { AppState } from '../reducers';
import { MediaFile } from '../../typings/mediaFiles';

const EMPTY_MEDIA_FILES: MediaFile[] = [];

export const selectMediaFiles =
    (companyId: string) =>
    (state: AppState): MediaFile[] =>
        state.mediaFiles.files[companyId] ?? EMPTY_MEDIA_FILES;
